import { Dropdown, Input, Trans } from '@/components'

type Status = 'all' | 'active' | 'inactive' | 'pending'
type Bind = 'all' | 'bound' | 'unbound'

interface FiltersBarProps {
  status: Status
  bind: Bind
  search: string
  onStatusChange: (v: Status) => void
  onBindChange: (v: Bind) => void
  onSearchChange: (v: string) => void
  right?: React.ReactNode
}

export function FiltersBar({
  status,
  bind,
  search,
  onStatusChange,
  onBindChange,
  onSearchChange,
  right,
}: FiltersBarProps) {
  return (
    <div className="mt-6 flex justify-between items-end">
      <div className="flex gap-6 flex-wrap">
        <div className="flex flex-col z-30">
          <span className="t-sb mb-2">
            <Trans i18nKey="team.member.status">Status</Trans>
          </span>
          <Dropdown
            rootClassName="w-60"
            className="h-11"
            options={[
              { label: <Trans i18nKey="team.member.all">All</Trans>, value: 'all' },
              { label: <Trans i18nKey="team.member.active">Active</Trans>, value: 'active' },
              { label: <Trans i18nKey="team.member.inactive">Inactive</Trans>, value: 'inactive' },
            ]}
            value={status}
            onChange={(v: any) => onStatusChange(v as Status)}
          />
        </div>

        <div className="flex flex-col">
          <span className="t-sb mb-2">
            <Trans i18nKey="team.member.bindStatus">Bind Status</Trans>
          </span>
          <Dropdown
            rootClassName="w-60"
            className="h-11"
            options={[
              { label: <Trans i18nKey="team.member.all">All</Trans>, value: 'all' },
              { label: <Trans i18nKey="team.member.bound">Bound</Trans>, value: 'bound' },
              { label: <Trans i18nKey="team.member.unbound">Unbound</Trans>, value: 'unbound' },
            ]}
            value={bind}
            onChange={(v: any) => onBindChange(v as Bind)}
          />
        </div>

        <div className="flex flex-col">
          <span className="t-sb mb-2">
            <Trans i18nKey="team.member.search">Search</Trans>
          </span>
          <Input
            className="w-60 h-11 t-sb"
            placeholder="Search name / account"
            value={search}
            allowClear
            onChange={(e) => onSearchChange(e.target.value)}
            onClear={() => onSearchChange('')}
          />
        </div>
      </div>
      <div className="flex gap-2">{right}</div>
    </div>
  )
}
